// Meal/day templates — save a day or a single meal, reapply anywhere later. Ported
// verbatim from the original app's MEAL TEMPLATES section.
import { S, MEALS, MEAL_LABELS } from '../state.js';
import { save } from '../lib/sync.js';
import { openSheet, closeSheet, openModal, closeModal } from '../lib/modal.js';
import { escHtml, uid } from '../lib/format.js';
import { IC, cicon } from '../lib/icons.js';
import { showToast } from './toast.js';
import { showConfirm } from './confirmDialog.js';
import { getFoodDate, renderFood } from '../pages/food.js';
import { renderHome } from '../pages/home.js';
import { today } from '../lib/dates.js';

export function openTemplates() {
  renderTemplatesList();
  openSheet('shTemplates');
}

export function renderTemplatesList() {
  const el = document.getElementById('templatesList');
  if (!S.templates.length) {
    el.innerHTML = `<div class="empty" style="padding:20px 0"><div class="empty-icon">${cicon('list', 28)}</div><div class="empty-text">Шаблонов пока нет</div><div class="empty-sub">Сохрани день или отдельный приём пищи — потом применишь в один тап</div></div>`;
    return;
  }
  el.innerHTML = S.templates.map(t => {
    const badge = t.type === 'day' ? 'Весь день' : MEAL_LABELS[t.meal];
    return `<div class="card card-sm" style="margin-bottom:8px;display:flex;justify-content:space-between;align-items:center;gap:8px">
      <div style="flex:1;min-width:0">
        <div style="font-weight:700;font-size:13px">${escHtml(t.name)}</div>
        <div class="t-secondary" style="font-size:11px">${badge}</div>
      </div>
      <div style="display:flex;gap:4px;flex-shrink:0;align-items:center">
        <button class="btn btn-sm btn-primary" onclick="applyTemplate('${t.id}')">Применить</button>
        <button onclick="delTemplate('${t.id}')" class="dish-btn">${IC.trash}</button>
      </div>
    </div>`;
  }).join('');
}

export function applyTemplate(id) {
  const t = S.templates.find(x => x.id === id);
  if (!t) return;
  const foodDate = getFoodDate();
  if (!S.foodLog[foodDate]) S.foodLog[foodDate] = { breakfast: [], lunch: [], dinner: [], snacks: [] };
  if (t.type === 'day') {
    MEALS.forEach(m => {
      (t.items[m] || []).forEach(it => {
        S.foodLog[foodDate][m].push(Object.assign(JSON.parse(JSON.stringify(it)), { eaten: true }));
      });
    });
  } else {
    (t.items || []).forEach(it => {
      S.foodLog[foodDate][t.meal].push(Object.assign(JSON.parse(JSON.stringify(it)), { eaten: true }));
    });
  }
  save(true);
  closeSheet('shTemplates');
  renderFood();
  if (foodDate === today()) renderHome();
}

export function delTemplate(id) {
  showConfirm('Удалить шаблон?', () => {
    S.templates = S.templates.filter(t => t.id !== id);
    save(true);
    renderTemplatesList();
  });
}

let stType = 'day', stMeal = 'breakfast';

export function setStType(t, btn) {
  stType = t;
  document.querySelectorAll('#stTypeGroup .toggle-btn').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
  document.getElementById('stMealRow').style.display = t === 'meal' ? '' : 'none';
}

export function setStMeal(m, btn) {
  stMeal = m;
  document.querySelectorAll('#stMealGroup .toggle-btn').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
}

export function openSaveTemplate() {
  stType = 'day'; stMeal = 'breakfast';
  document.querySelectorAll('#stTypeGroup .toggle-btn').forEach((b, i) => b.classList.toggle('on', i === 0));
  document.querySelectorAll('#stMealGroup .toggle-btn').forEach((b, i) => b.classList.toggle('on', i === 0));
  document.getElementById('stMealRow').style.display = 'none';
  document.getElementById('stName').value = '';
  openModal('shSaveTemplate');
}

export function saveTemplate() {
  const name = document.getElementById('stName').value.trim();
  if (!name) { showToast('Введи название шаблона'); return; }
  const foodDate = getFoodDate();
  const fl = S.foodLog[foodDate] || { breakfast: [], lunch: [], dinner: [], snacks: [] };
  const stripEaten = arr => (arr || []).map(it => { const c = JSON.parse(JSON.stringify(it)); delete c.eaten; return c; });
  let tpl;
  if (stType === 'day') {
    const hasAny = MEALS.some(m => (fl[m] || []).length);
    if (!hasAny) { showToast('В этот день ничего не внесено — нечего сохранять'); return; }
    tpl = { id: 'tpl' + uid(), name, type: 'day', items: {
      breakfast: stripEaten(fl.breakfast), lunch: stripEaten(fl.lunch), dinner: stripEaten(fl.dinner), snacks: stripEaten(fl.snacks),
    } };
  } else {
    const items = fl[stMeal] || [];
    if (!items.length) { showToast('В этом приёме пищи пусто — нечего сохранять'); return; }
    tpl = { id: 'tpl' + uid(), name, type: 'meal', meal: stMeal, items: stripEaten(items) };
  }
  S.templates.push(tpl);
  save(true);
  closeModal('shSaveTemplate');
  renderTemplatesList();
}
